import { useSelector } from "react-redux";
import { hasAdminAccess } from "../../../utils/roles";
import ClubSubscriptionInlineBanner from "../../common/ClubSubscription/ClubSubscriptionInlineBanner";
import aa from "./adminApp.module.css";

export default function AdminTrialBanner({
  profilePath = "/manage/app/profile/account/billing",
  appMode = true,
}) {
  const { billing, tenant, role } = useSelector((state) => state.auth);
  const canPay = hasAdminAccess(role);

  if (!billing?.is_paid) return null;

  const daysLeft = billing.days_left;
  const showTrial = billing.is_trial && daysLeft != null && daysLeft >= 0;
  const showSoon = billing.is_expiring_soon && !billing.is_trial;
  if (!showTrial && !showSoon) return null;

  return (
    <div className={appMode ? aa.trialBannerApp : ""}>
      <ClubSubscriptionInlineBanner
        billing={billing}
        clubName={tenant?.name || billing?.club_name}
        profilePath={profilePath}
        compact={false}
        showCta={canPay}
        ctaLabel={canPay ? undefined : "Подробнее"}
      />
    </div>
  );
}
